import ActionConfirmationModal from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal'
import { usePortal } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/parts/CancelOrderConfirmationModal/contexts/Portal'
import { useCloseOnPosModeChange } from '@/features/pos/hooks/useCloseOnPosModeChange'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface CancelOrderConfirmationModalProps {
    open: boolean
    onConfirm: () => void
    onClose: () => void
}

const CancelOrderConfirmationModal: FC<CancelOrderConfirmationModalProps> = ({
    open,
    onConfirm,
    onClose,
}) => {
    const { t } = useTranslation()

    const MemoizedCartItemDeleteConfirmationModal = useMemo(
        () => (
            <ActionConfirmationModal
                action={t('pos.orderFinalization.confirmCancelOrderMessage')}
                onConfirm={onConfirm}
                onCancel={onClose}
            />
        ),
        [t, onConfirm, onClose]
    )

    usePortal(open, MemoizedCartItemDeleteConfirmationModal)

    useCloseOnPosModeChange(onClose)

    return null
}

export default CancelOrderConfirmationModal
